import { ApiType } from "@gymflow/common";
import { GetUserMemberAccessLogRequestParams } from "@gymflow/common/lib/api/accessApi";
import { useInfiniteQuery } from "@tanstack/react-query";

import { accessQueryKeys } from "./accessQueryKeys";

export const useInfiniteQueryUserMemberAccessLog = ({
  api,
  params,
}: {
  api: ApiType;
  params: GetUserMemberAccessLogRequestParams;
}) =>
  useInfiniteQuery({
    queryKey: accessQueryKeys.getUserMemberAccessLog(params),
    queryFn: async ({ pageParam }: { pageParam?: string }) =>
      (
        await api.accessApi.getUserMemberAccessLog({
          ...params,
          nextPageToken: pageParam,
        })
      ).data,
    getNextPageParam: (lastPage) => lastPage?.nextPageToken,
    initialPageParam: undefined,
  });
